module.exports = require('./modules/components/Routes');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/Routes.js
// module id = 209
// module chunks = 0